<!--
/**
 * DjNumberControlTab.vue - 漫游管控 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的漫游管控页面，用于管理号码的漫游地管控。
 * 可以添加号码到管控列表（指定收货地市），当号码的漫游地与收货地市不一致时，
 * 系统会自动进行异常停机处理，防止号码在非授权地区使用。
 *
 * 【主要功能】
 * 1. 管控记录查询 - 按号码搜索管控列表中的记录
 * 2. 添加管控号码 - 手动输入号码和收货地市，将号码加入管控列表
 * 3. 删除管控号码 - 支持单个删除和批量删除（选中删除/输入号码删除）
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 *
 * 【注意事项】
 * - 收件地址地市与漫游地不一致时，号码将被异常停机
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码搜索输入框 -->
      <el-input size="small" v-model="query12.phone" clearable maxlength="12" placeholder="电话号码"
                class="handle-input mr10"></el-input>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getopenControlList">搜索
      </el-button>
      <!-- 添加按钮 - 打开添加弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" @click="handleAdd12">添加</el-button>
      <!-- 批量删除按钮 - 批量删除选中记录或打开删除弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-delete"
                 @click="batchDel">批量删除
      </el-button>
    </div>

    <!-- ========== 管控记录表格 ========== -->
    <el-table :data="tableData12" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
              @selection-change="handleSelectionChange" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" stripe v-loading="loading">
      <!-- 多选列（用于批量操作） -->
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <!-- 电话号码 -->
      <el-table-column prop="phone" label="电话号码" align="center"></el-table-column>
      <!-- 城市（收货地市） -->
      <el-table-column prop="city" label="城市" align="center"></el-table-column>
      <!-- 添加时间 -->
      <el-table-column prop="time" label="时间" align="center"></el-table-column>
      <!-- 添加人 -->
      <el-table-column prop="userPhone" label="添加人" align="center"></el-table-column>
      <!-- 操作列 - 单个删除 -->
      <el-table-column label="操作" width="190" align="center">
        <template #default="scope">
          <el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
                     @click="separateDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query12.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query12.pageSize" :total="pageTotal12" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 添加弹窗 ========== -->
    <!-- 添加号码到漫游管控列表 -->
    <el-dialog title="添加" v-model="addVisible12" width="650px" @close="closeDialog12">
      <el-form :model="addForm12" ref="addForm12" label-width="120px">
        <!-- 提示信息 -->
        <el-form-item label="" prop="">
          <span style="color: #ff0000;font-size: 12px;">*注释:收件地址地市与漫游地，不一致，将会漫游地异常停机</span>
        </el-form-item>
        <!-- 收货地市输入 -->
        <el-form-item label="收货地市">
          <el-input size="small" v-model="addForm12.city" placeholder="请输入收货地市"></el-input>
        </el-form-item>
        <!-- 添加号码（一行一个，最多100个） -->
        <el-form-item label="添加号码">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
                    v-model="addForm12.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog12">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getAdd12">添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== 批量删除弹窗 ========== -->
    <!-- 通过输入号码列表进行批量删除 -->
    <el-dialog title="批量删除" v-model="deleteVisible12" width="800px" @close="closeDialog12"
               :close-on-click-modal="false">
      <el-form :model="deleteForm12" ref="deleteForm12" label-width="100px">
        <!-- 输入要删除的号码（一行一个，最多100个） -->
        <el-form-item label="删除号码" prop="phones">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个删除单号码,一次最多删除100个号码"
                    v-model="deleteForm12.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" type="primary" :class="[theme]" @click="closeDialog12">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="batchDel2">确认删除</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 漫游管控 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - openControl：添加号码到漫游管控列表
 * - openControlList：查询漫游管控列表
 * - openControlDelete：删除漫游管控记录
 */
import {
  openControl,
  openControlList,
  openControlDelete
} from '../../../api/index.js';

export default {
  name: 'DjNumberControlTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   */
  props: {
    theme: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      multipleSelection: [],    // 多选的行数据数组
      query12: {                // 查询参数
        phone: '',              // 手机号
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        userId: localStorage.getItem('user'),
      },
      tableData12: [],          // 管控记录列表
      pageTotal12: 0,           // 总条数

      // ========== 添加弹窗相关 ==========
      addVisible12: false,      // 添加弹窗是否显示
      addForm12: {              // 添加表单
        phones: '',             // 号码（一行一个）
        city: '',               // 收货地市
        userId: localStorage.getItem('user'),
      },

      // ========== 批量删除弹窗相关 ==========
      deleteVisible12: false,   // 删除弹窗是否显示
      deleteForm12: {           // 删除表单
        ids: '',                // ID列表（选中行删除用）
        phones: '',             // 号码列表（输入删除用）
      },
    };
  },

  /**
   * 组件创建时查询管控列表
   */
  created() {
    this.getopenControlList();
  },

  methods: {
    /**
     * handleSelectionChange - 多选变化回调
     * @param {Array} val - 当前选中的行数据数组
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**
     * getopenControlList - 查询漫游管控列表
     */
    getopenControlList() {
      this.loading = true;
      openControlList(this.query12).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData12 = res.data.list;
          this.pageTotal12 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handleAdd12 - 打开添加弹窗，清空表单
     */
    handleAdd12() {
      this.addForm12.city = '';
      this.addForm12.phones = '';
      this.addVisible12 = true;
    },

    /**
     * getAdd12 - 提交添加号码到管控列表
     */
    getAdd12() {
      openControl(this.addForm12).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addVisible12 = false;
          this.getopenControlList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * closeDialog12 - 关闭所有弹窗并重置表单
     */
    closeDialog12() {
      this.addForm12.city = '';
      this.addForm12.phones = '';
      this.addVisible12 = false;
      this.deleteForm12.phones = '';
      this.deleteVisible12 = false;
    },

    /**
     * batchDel - 批量删除操作
     * 如果有选中行，则直接按ID删除；如果没有选中行，打开批量删除弹窗（输入号码删除）
     */
    batchDel() {
      let str = '';
      for (let i = 0; i < this.multipleSelection.length; i++) {
        str += this.multipleSelection[i].id + ',';
      }
      if (str === '') {
        // 未选中行，打开输入号码删除弹窗
        this.deleteForm12.phones = '';
        this.deleteVisible12 = true;
      } else {
        // 有选中行，直接按ID删除
        this.$confirm('确定要删除吗？', '提示', { type: 'warning' })
          .then(() => {
            let param = {
              ids: str,
              userId: localStorage.getItem('user')
            };
            openControlDelete(param).then(res => {
              if (res?.code === 200) {
                this.$message.success('删除成功');
                this.getopenControlList();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {});
      }
      this.multipleSelection = [];
    },

    /**
     * batchDel2 - 输入号码批量删除
     * 通过输入的号码列表进行批量删除
     */
    batchDel2() {
      this.$confirm('确定要删除吗？', '提示', { type: 'warning' })
        .then(() => {
          let param = {
            phones: this.deleteForm12.phones,
            userId: localStorage.getItem('user')
          };
          openControlDelete(param).then(res => {
            if (res?.code === 200) {
              this.$message.success('删除成功');
              this.deleteForm12.phones = '';
              this.deleteVisible12 = false;
              this.getopenControlList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    /**
     * separateDelete - 单个删除管控记录
     * @param {Object} row - 要删除的行数据
     */
    separateDelete(row) {
      this.$confirm('确定要删除吗？', '提示', { type: 'warning' }).then(() => {
        let param = {
          ids: row.id,
          userId: localStorage.getItem('user'),
        };
        openControlDelete(param).then(res => {
          if (res?.code === 200) {
            this.$message.success('删除成功');
            this.getopenControlList();
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {});
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query12.pageIndex = val;
      this.getopenControlList();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query12.pageSize = val;
      this.query12.pageIndex = 1;
      this.getopenControlList();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
